// pager: src/router/config.tsx
// page src/router/config.tsx
import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';
import { lazy } from "react";


import Home from '../pages/home/page';
import Dashboard from '../pages/dashboard/page';
import Onboarding from '../pages/onboarding/page';
import BrandOnboarding from '../pages/brand-onboarding/page';
import ContentOnboarding from '../pages/content-onboarding/page';
import AsIsPage from '../pages/asis/page';
import NotFound from '../pages/NotFound';
import Login from '../pages/Login';
import OnboardingSuccess from '../pages/OnboardingSuccess';
import AgencyDashboard from '../pages/agency-dashboard/page';
import MarketingIntricacies from '../pages/marketing-intricacies/page';
import ContentManager from '../pages/content-engine/page';
import ProtectedRoute from '../components/ProtectedRoute';
import WebsiteBuilder from '../pages/website-builder/page';
import UtilityManager from '../pages/utility-manager/page';
import GMBManager from '../pages/gmb-manager/page';
import GMBOnboarding from '../pages/gmb-onboarding/page';
const ProfileSettings = lazy(() => import("../pages/profile/page"));
const ReportingPage = lazy(() => import("../pages/reporting/page"));
const RaiseTicketPage = lazy(() => import("../pages/support/tickets/new/page"));
const TicketListPage = lazy(() => import("../pages/support/tickets/list/page"));
const TicketDetailsPage = lazy(() => import("../pages/support/tickets/detail/page"));

import SubscriptionPage from "../pages/subscription/page";
import CreditsPage from "../pages/credits/page";
import PaymentSuccess from "../pages/payment/success";
import PaymentFailure from "../pages/payment/failure";
import CheckoutPage from "../pages/subscription/checkout/page";

function DefaultRedirect() {
  const accountType = localStorage.getItem('account_type');
  if (accountType === 'brand') return <Navigate to="/marketing-dashboard" replace />;
  if (accountType === 'agency') return <Navigate to="/agency-dashboard" replace />;
  return <Navigate to="/?login=true" replace />;
}

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute requiredRole="brand">
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: '/as-is',
    element: <AsIsPage />,
  },
  {
    path: '/onboarding',
    element: <Onboarding />,
  },
  {
    path: '/brand-onboarding',
    element: <BrandOnboarding />,
  },
  {
    path: '/content-onboarding',
    element: (
      <ProtectedRoute requiredRole="brand">
        <ContentOnboarding />
      </ProtectedRoute>
    ),
  },
  {
    path: '/onboarding/success',
    element: <OnboardingSuccess />,
  },
  {
    path: '/login',
    element: <Navigate to="/?login=true" replace />,
  },
  {
    path: '/agency-dashboard',
    element: (
      <ProtectedRoute requiredRole="agency">
        <AgencyDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: '/analytics',
    element: (
      <ProtectedRoute requiredRole="agency">
        <AgencyDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: '/marketing-dashboard',
    element: (
      <ProtectedRoute requiredRole="brand">
        <MarketingIntricacies />
      </ProtectedRoute>
    ),
  },
  {
    path: '/social-media-manager/*',
    element: (
      <ProtectedRoute requiredRole="brand">
        <ContentManager />
      </ProtectedRoute>
    ),
  },
  {
    path: '/profile',
    element: (
      <ProtectedRoute requiredRole={['brand', 'agency']}>
        <ProfileSettings />
      </ProtectedRoute>
    ),
  },
  {
    path: '/reporting',
    element: (
      <ProtectedRoute requiredRole={['brand', 'agency']}>
        <ReportingPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/website-builder',
    element: <WebsiteBuilder />,
  },
  {
    path: '/utility-manager',
    element: (
      <ProtectedRoute requiredRole="brand">
        <UtilityManager />
      </ProtectedRoute>
    ),
  },
  {
    path: '/gmb-manager',
    element: __ENABLE_GMB_MODULE__ ? (
      <ProtectedRoute requiredRole="brand">
        <GMBManager />
      </ProtectedRoute>
    ) : (
      <Navigate to="/marketing-dashboard" replace />
    ),
  },
  {
    path: '/gmb-onboarding',
    element: __ENABLE_GMB_MODULE__ ? (
      <ProtectedRoute requiredRole="brand">
        <GMBOnboarding />
      </ProtectedRoute>
    ) : (
      <Navigate to="/marketing-dashboard" replace />
    ),
  },
  {
    children: [
      {
        path: '',
        element: <DefaultRedirect />,
      },
      {
        path: '*',
        element: <DefaultRedirect />,
      },
    ],
  },
  {
    path: '/subscription',
    element: <SubscriptionPage />,
  },
  {
    path: '/credits',
    element: (
      <ProtectedRoute requiredRole="brand">
        <CreditsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/subscription/checkout',
    element: <CheckoutPage />,
  },
  {
    path: '/payment/success',
    element: <PaymentSuccess />,
  },
  {
    path: '/payment/failure',
    element: <PaymentFailure />,
  },

  {
    path: '/support/tickets/new',
    element: (
      <ProtectedRoute requiredRole="brand">
        <RaiseTicketPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/support/tickets',
    element: (
      <ProtectedRoute requiredRole="brand">
        <TicketListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '/support/tickets/:ticketId',
    element: (
      <ProtectedRoute requiredRole="brand">
        <TicketDetailsPage />
      </ProtectedRoute>
    ),
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
